import React, { useState, useEffect } from 'react';
import '../../assets/css/PropertyFilter.css';

const PropertyFilter = ({ filters, onFilterChange }) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [propertyStatuses, setPropertyStatuses] = useState([]);
  const [propertyLocations, setPropertyLocations] = useState([]);
  
  useEffect(() => {
    // Fetch property types
    fetch('/wp-json/wp/v2/property_type?per_page=100')
      .then(response => response.json())
      .then(data => setPropertyTypes(data))
      .catch(error => console.error('Error fetching property types:', error));
    
    // Fetch property statuses
    fetch('/wp-json/wp/v2/property_status?per_page=100')
      .then(response => response.json())
      .then(data => setPropertyStatuses(data))
      .catch(error => console.error('Error fetching property statuses:', error));
    
    // Fetch property locations
    fetch('/wp-json/wp/v2/property_location?per_page=100')
      .then(response => response.json())
      .then(data => setPropertyLocations(data))
      .catch(error => console.error('Error fetching property locations:', error));
  }, []);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onFilterChange(localFilters);
  };
  
  const handleReset = () => {
    const resetFilters = {
      price_min: '',
      price_max: '',
      bedrooms: '',
      bathrooms: '',
      property_type: '',
      property_status: '',
      property_location: ''
    };
    setLocalFilters(resetFilters);
    onFilterChange(resetFilters);
  };
  
  return (
    <div className="property-filter">
      <h2>Find Your Perfect Property</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="property-filter__row">
          <div className="property-filter__field">
            <label htmlFor="property_type">Property Type</label>
            <select
              id="property_type"
              name="property_type"
              value={localFilters.property_type}
              onChange={handleInputChange}
            >
              <option value="">All Property Types</option>
              {propertyTypes.map(type => (
                <option key={type.id} value={type.slug}>{type.name}</option>
              ))}
            </select>
          </div>
          
          <div className="property-filter__field">
            <label htmlFor="property_status">Status</label>
            <select
              id="property_status"
              name="property_status"
              value={localFilters.property_status}
              onChange={handleInputChange}
            >
              <option value="">All Statuses</option>
              {propertyStatuses.map(status => (
                <option key={status.id} value={status.slug}>{status.name}</option>
              ))}
            </select>
          </div>
          
          <div className="property-filter__field">
            <label htmlFor="property_location">Location</label>
            <select
              id="property_location"
              name="property_location"
              value={localFilters.property_location}
              onChange={handleInputChange}
            >
              <option value="">All Locations</option>
              {propertyLocations.map(location => (
                <option key={location.id} value={location.slug}>{location.name}</option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="property-filter__row">
          <div className="property-filter__field property-filter__field--half">
            <label htmlFor="price_min">Min Price</label>
            <input
              type="number"
              id="price_min"
              name="price_min"
              placeholder="Min Price"
              value={localFilters.price_min}
              onChange={handleInputChange}
              min="0"
            />
          </div>
          
          <div className="property-filter__field property-filter__field--half">
            <label htmlFor="price_max">Max Price</label>
            <input
              type="number"
              id="price_max"
              name="price_max"
              placeholder="Max Price"
              value={localFilters.price_max}
              onChange={handleInputChange}
              min="0"
            />
          </div>
          
          <div className="property-filter__field property-filter__field--third">
            <label htmlFor="bedrooms">Bedrooms</label>
            <select
              id="bedrooms"
              name="bedrooms"
              value={localFilters.bedrooms}
              onChange={handleInputChange}
            >
              <option value="">Any</option>
              <option value="1">1+</option>
              <option value="2">2+</option>
              <option value="3">3+</option>
              <option value="4">4+</option>
              <option value="5">5+</option>
            </select>
          </div>
          
          <div className="property-filter__field property-filter__field--third">
            <label htmlFor="bathrooms">Bathrooms</label>
            <select
              id="bathrooms"
              name="bathrooms"
              value={localFilters.bathrooms}
              onChange={handleInputChange}
            >
              <option value="">Any</option>
              <option value="1">1+</option>
              <option value="2">2+</option>
              <option value="3">3+</option>
              <option value="4">4+</option>
              <option value="5">5+</option>
            </select>
          </div>
        </div>
        
        <div className="property-filter__actions">
          <button type="submit" className="button button--primary">Search Properties</button>
          <button type="button" className="button button--secondary" onClick={handleReset}>Reset Filters</button>
        </div>
      </form>
    </div>
  );
};

export default PropertyFilter;